var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 5.875H3.4375V5.0625H2.625V5.875ZM5.875 5.0625H6.6875V4.25H5.875V5.0625ZM7.5 5.0625H8.3125V4.25H7.5V5.0625ZM9.125 5.0625H9.9375V4.25H9.125V5.0625ZM5.875 3.4375H6.6875V2.625H5.875V3.4375ZM7.5 3.4375H8.3125V2.625H7.5V3.4375ZM9.125 3.4375H9.9375V2.625H9.125V3.4375ZM5.875 8.3125H6.6875V7.5H5.875V8.3125ZM7.5 8.3125H8.3125V7.5H7.5V8.3125ZM9.125 8.3125H9.9375V7.5H9.125V8.3125ZM5.875 9.9375H6.6875V9.125H5.875V9.9375ZM9.125 9.9375H9.9375V9.125H9.125V9.9375ZM5.875 11.5625H6.6875V10.75H5.875V11.5625ZM9.125 11.5625H9.9375V10.75H9.125V11.5625ZM11.5625 10.75H12.375V9.9375H11.5625V10.75ZM11.5625 8.3125V9.125H12.375V8.3125H11.5625ZM11.5625 12.375H12.375V11.5625H11.5625V12.375ZM5.875 6.6875H6.6875V5.875H5.875V6.6875ZM7.5 6.6875H8.3125V5.875H7.5V6.6875ZM9.125 6.6875H9.9375V5.875H9.125V6.6875ZM2.625 7.5H3.4375V6.6875H2.625V7.5ZM2.625 9.125H3.4375V8.3125H2.625V9.125ZM2.625 10.75H3.4375V9.9375H2.625V10.75ZM2.625 12.375H3.4375V11.5625H2.625V12.375ZM7.5 9.9375H8.3125V9.125H7.5V9.9375Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1875 13.1875C13.1875 13.6366 12.8241 14 12.375 14H1.8125C1.36339 14 1 13.6366 1 13.1875V4.25C1 3.80089 1.36339 3.4375 1.8125 3.4375H4.25V1.8125C4.25 1.36339 4.61339 1 5.0625 1H10.75C11.1991 1 11.5625 1.36339 11.5625 1.8125V6.6875H12.375C12.8241 6.6875 13.1875 7.05089 13.1875 7.5V13.1875ZM4.25 4.25H1.8125V13.1875H4.25V4.25ZM10.75 1.8125H5.0625V13.1875H7.5V10.75H8.3125V13.1875H10.75V1.8125ZM12.375 7.5H11.5625V13.1875H12.375V7.5Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectMaster);
export default __webpack_public_path__ + "static/media/Project Master.979ec8157066b1d0e6aaf87c9f226113.svg";
export { ForwardRef as ReactComponent };